import PageBase from '@/sag-core/base/PageBase'
import pageStore from './store'
import tools from '@/sag-core/tools'
import { $themeColors } from '@themeConfig'
import { reactive } from '@vue/composition-api'
const pageInfo = {
    serviceName: 'APSSIDUI03',
    pageStore: pageStore
}
export default {
    pageInfo: pageInfo,
    pageInit(){
        const page = new PageBase(pageInfo)
        tools.mergeDeep(this, page)

        return {
       
        }
    }
}

